<template>
  <section class="main grid grid-rows bg-slate-100">
    <div class="px-8 bg-pdsPrimaryColor content-center justify-start">
      <router-link to="/">
        <img class="w-32 my-6" alt="Mediq TEFA" src="@/static/img/mediq_logo.svg" />
      </router-link>
    </div>
    <div class="text-white font-bold p-0 bg-primary-default">
      <div class="ml-auto px-10">
        <div class="grid grid-rows md:grid-cols md:grid-rows-1 md:grid-cols-2">
          <div class="py-4">
            <!-- Back Link -->
            <div class="text-sm mb-1 cursor-pointer -ml-1">
              <router-link to="/">
                <ChevronLeftIcon class="h-5 w-5 inline-block" aria-hidden="true" />
                <span class="align-middle">{{ navigationBackText }}</span>
              </router-link>
            </div>
            <h1 class="text-2xl font-bold tracking-tight text-white m-0 pl-1">{{ pageTitle }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto content-center mt-8 mb-40">
      <router-view />
    </div>
  </section>
</template>

<script>
import { ChevronLeftIcon } from '@heroicons/vue/20/solid';
import { ref } from 'vue';
export default {
  name: 'Mainstandalone',
  components: {
    ChevronLeftIcon
  },
  beforeRouteUpdate(to, from, next) {
    this.routerCurrentPath = to.path;
    next();
  },
  setup() {
    const pageTitle = ref('');
    const navigationBackText = ref('');
    return {
      pageTitle,
      navigationBackText
    };
  }
};
</script>
